"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("../../constants");
const PLACEHOLDERS = {
    bool: constants_1.DEFAULT_OPTIONS_TAB_PLACEHOLDER_TEXT,
    'pretty-select': constants_1.DEFAULT_OPTIONS_TAB_PLACEHOLDER_TEXT,
};
function getDefaultPlaceholderText({ type, listItemType, }, hasChoiceGroups) {
    const placeholderType = type === 'list' && listItemType ? listItemType : type;
    return (PLACEHOLDERS[placeholderType] ||
        (hasChoiceGroups
            ? constants_1.DEFAULT_PLACEHOLDER_TEXT
            : constants_1.DEFAULT_PLACEHOLDER_TEXT_FOR_TRIGGER));
}
exports.default = getDefaultPlaceholderText;
